import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import VakmanschapInKalkzandsteen from "./sections/VakmanschapInKalkzandsteen";
import RentInThreeSimpleSteps from "./sections/RentInThreeSimpleSteps";
import BecomeAPartner from "./sections/BecomeAPartner";
import OurGrowingCommunity from "./sections/OurGrowingCommunity";
import TestimonialsSlider from "./sections/TestimonialsSlider";
import Testimonials from "./sections/Testimonials";
import FindAChargingStation from "./sections/FindAChargingStation";
import CallToAction from "./sections/CallToAction";
import Statistics from "./sections/Statistics";
import ReadyToCharge from "./sections/ReadyToCharge";
import StartJeAvontuur from "./sections/StartJeAvontuur";
import Pricing from "./sections/Pricing";
import VoltGoFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <VakmanschapInKalkzandsteen />
      <RentInThreeSimpleSteps />
      <BecomeAPartner />
      <OurGrowingCommunity />
      <TestimonialsSlider />
      <Testimonials />
      <FindAChargingStation />
      <CallToAction />
      <Statistics />
      <ReadyToCharge />
      <StartJeAvontuur />
      <Pricing />
      <VoltGoFooter />
    </div>;
}